import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/locale.js';
// import Util from '@/helper/Utility.js';
//core
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
//config
import { RedeemConfigBuilder } from '@/core/Redeem/config/RedeemConfigBuilder.js';
//model
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
//service
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import { DrawDeliveryModel } from '@/core/Redeem/model/DrawDeliveryModel.js';
import { DonateModel } from'@/core/Redeem/model/DonateModel.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import ConfigManager from '@/config/ConfigManager.js';
// import { ModalController } from '../../../components/Modal/ModalController';

/**
 * event
 * @method onRedeemSuccess
 * @method onErrorApi
 * @method onRedirect
 */
export function RedeemController () {
    this.lbl = Locale.getLbl();
    this.localeCode = Locale.getLocaleCode();
    this.cacheHelper = new CacheHelper();

    this.campaign = {};
    this.selectedCampaignId = null;
    this.selectedQuantity = null;

    this.redeemConfigBuilder = new RedeemConfigBuilder();
    this.modalController = null;

    this.cbRedeemSuccess = new CallbackEvent();
    this.cbRedirect = new CallbackEvent();
    this.cbApiError = new CallbackEvent();

    this.usePoint = null;
    //#region initial
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     * @param {ModalController} modalController /components/Modal/ModalController.js
     */
    this.initial = (campaign, modalController) => {
        this.campaign = campaign;
        this.modalController = modalController;
    };
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.reinitial = (campaign) => {
        this.lbl = Locale.getLbl();
        this.campaign = campaign;
    }
    //#endregion initial

    //#region redeem
    /**
     * @param {Number} selectedCampaignId campaign id
     * @param {Number} selectedQuantity quanty
     */
    this.clickRedeem = (selectedCampaignId, selectedQuantity, tracking) => {
        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;

        if (this.campaign.type == Vue.CampaignType.Donate) {
            this.campaign.usePoint = this.usePoint
        }

        this.modalController.confirmRedeemModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .show()

        this.modalController.confirmRedeemModal.onClickConfirm(() => {
            // event confirm redeem
            this.confirmRedeem();
            let trackCamp = this.campaign.id + "|" + this.campaign.name;
            tracking.event('confirm_redeem', 'click_confirm_redeem', trackCamp);
        });

        this.modalController.confirmRedeemModal.onClickCancel(() => {
            // event cancel redeem
        });
    };
    this.confirmRedeem = () => {
        if (this.campaign.type == Vue.CampaignType.Interface) {
            switch (this.campaign.interfaceDisplay) {
                case 'web':
                    this.openWebInterface();
                    break;
                case 'survey':
                case 'surveyapprove':
                    //TODO: Setup link
                    this.openWebInterface();
                    // var surveyUrl = this.campaign.website;
                    // this.eventRedirect({ type: 'web', link: surveyUrl })
                    break;
                case 'api':
                    this.eventRedirect();
                    break;
            }
        } else if (this.campaign.type == Vue.CampaignType.Buy) {
            this.addToCart();
        } else if (this.campaign.delivered) {
            if(this.campaign.type == Vue.CampaignType.Privilege){
                this.addToCart('isClearCart');
            }else{
                var shippingProfile = Account.getCacheProfileShippingAddres();
                console.log("ship", shippingProfile);
                this.modalController.shippingAddressModal
                    .setTag('shipping-profile')
                    .setShippingProfile(shippingProfile)
                    .show();

                this.modalController.shippingAddressModal
                    .cbAction.onCallback(address => {
                        this.flowConfirmAddress(address);
                });
            }
            
        } else if (this.campaign.type == Vue.CampaignType.Privilege) {
            this.addToCart('isClearCart');
        } else {
            this.redeem();
        }


    };
    this.flowConfirmAddress = (address) => {
        this.modalController.confirmDeliveryAddressModal
            .clearModal()
            .setAddress(address)
            .show();

        this.modalController.confirmDeliveryAddressModal.onClickConfirm(() => {
            this.redeem(address);
        });
        this.modalController.confirmDeliveryAddressModal.onClickCancel(() => {
            this.confirmRedeem();
        });
    }
    this.redeem = (address) => {

        if(address){
            this.redeemConfigBuilder.getRedeemShippingConfigBuilder();

            var strAddres = "";
                strAddres += address.address + " ";
                strAddres += address.subDistrictName + " ";
                strAddres += address.districtName + " ";
                strAddres += address.provinceName + " ";
                strAddres += address.zipcode;

            this.redeemConfigBuilder.redeemShippingAddressConfigBuilder
                                    .setFirstName(address.firstName)
                                    .setLastName(address.lastName)
                                    .setContactNumber(address.contactNumber)
                                    .setAddress(strAddres)
                                    .setZipcode(address.zipcode)
            if(address.isSaveAddress){
                console.log('address',address);
                Account.apiUpdateProfileShippingAddress(address);
            }
        }

        this.modalController.loadingModal.show();
        if (this.campaign.type == Vue.CampaignType.Donate) {

            var redeemOther = this.redeemConfigBuilder.getRedeemOtherConfigBuilder().redeemOtherConfigBuilder;
            redeemOther.setSpPoint(this.usePoint)
        }

        var token = Account.getToken();
        var params = this.redeemConfigBuilder.getRedeemParams();
        console.log("param", params);

        BzbsRedeem.apiRedeemCampaign(token, this.selectedCampaignId, params, this.selectedQuantity)
            .subscribe((campaign) => {
                this.modalController.loadingModal.hide();
                this.campaign.updateAfterRedeem(campaign);

                this.initialSerial();
                this.eventRedeemSuccess(campaign);

            }, (err) => {
                this.eventErrorApi(err);
                this.modalController.loadingModal.hide();
            });
    };

    //#endregion redeem

    //#region interface redeem open web
    this.openWebInterface = function() {
        //TODO: Setup link
        var webUrl = this.campaign.website;
        var isShowHeader = 'false';
        var theme = ConfigManager.getAppName();
        var suffledToken = Account.getTokenShuffle();
        let registerSurvey = this.cacheHelper.getCache('isRegisterSurvey');
        
        if(this.campaign.interfaceDisplay == 'surveyapprove' || this.campaign.interfaceDisplay == 'survey'){
            isShowHeader = true;
        }
         
        if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0) {
            this.cacheHelper.setCache('isfromlanding', 'interface');
        } else if (webUrl.indexOf('wondd') >= 0) {
            this.cacheHelper.setCache('isfromlanding', 'wodd');
        } else if ((webUrl.indexOf('surveyapprove') >= 0 || webUrl.indexOf('survey') >= 0) && registerSurvey == 'register_survey') {
            this.cacheHelper.setCache('isfromlanding', registerSurvey);
        } else if (webUrl.indexOf('datapackageinternet') >= 0) {
            this.cacheHelper.setCache('isfromlanding', 'datapackageinternet');
        } else {
            this.cacheHelper.setCache('isfromlanding', 'other');
        }
        
        webUrl += '&token=' + suffledToken
                + '&locale=' + this.localeCode
                + '&header=' + isShowHeader
                + '&theme=' + theme
                + '&return_url=' + encodeURIComponent(window.location.href);

        window.location.href = webUrl;
    };
    //#endregion interface redeem open web

    //#region buy
    this.addToCart = (isClearCart) => {
        //if (this.showLoading) return;

        var token = Account.getToken();
        var cartItem = new AddCartModel();
        var cartParams = cartItem.addItem(this.selectedCampaignId, this.selectedQuantity)

        if(isClearCart){
            cartParams = cartItem.setClearCart(true);
        }

        cartParams = cartItem.getParams();

        this.showLoading();
        BzbsCart.apiAddToCart(token, cartParams).subscribe((data) => {
            console.log(data);
            this.BuyRedirect();
            this.hideLoading();
        }, (err) => {
            this.hideLoading();
            this.eventErrorApi(err);
        });
    };
    this.BuyRedirect = () => {
        if (this.campaign.type == Vue.CampaignType.Privilege) {
            this.openWebBuy();
        }else{
            this.eventRedirect();
        }
    };
    this.openWebBuy = function() {
        //TODO: Setup link
        var webUrl = this.campaign.website;
        //var theme = ConfigManager.getAppName();
        var theme = 'ecommerce_brand_a';
        var suffledToken = Account.getTokenShuffle();
        var api = ConfigManager.getApi();
        var brand = ConfigManager.getAppName();
        var returnUrl = encodeURIComponent(window.location.href);
        var successUrl = encodeURIComponent(window.location.href);
        var strLocale = Locale.getLocaleCode();
        var appid = ConfigManager.getAppId();
        var multilang = true;

        webUrl = ConfigManager.getShoppingCartUrl() + "/marketplaceprivilege?"
            + "token=" + suffledToken
            + "&return_url=" + returnUrl
            + "&success_url=" + successUrl
            + "&theme=" + theme
            + "&appid=" + appid
            + "&brand=" + brand.toLowerCase()
            + "&multilang=" + multilang
            + "&api=" + api
            + "&locale=" + strLocale;

        window.location.href = webUrl;
    };
    //#endregion buy
    //#region serial
    this.initialSerial = () => {
        if (this.campaign.type == Vue.CampaignType.Draw) {
            var drawDelivery = new DrawDeliveryModel();
            console.log(drawDelivery);
            drawDelivery.setModelFromDataModel(this.campaign);
            this.modalController.drawDeliveryModal
                .setDrawDelivery(drawDelivery)
                .setTag('detail')
                .show();
        }else if (this.campaign.delivered) {
            this.modalController.freeDeliverySuccessModal
                .clearModal()
                .show();
            this.modalController.freeDeliverySuccessModal.onClickConfirm(()=>{
                //this.$router.push('/reward');
                this.eventRedirect({type: 'free-delivery'});
            });
        } else if (this.campaign.type == Vue.CampaignType.Donate) {
            var donate = new DonateModel();
            donate.setModelFromDataModel(this.campaign);
            //console.log('donate', donate);
            this.modalController.donateSuccessModal
                .setDonate(donate)
                .setTag('detail')
                .show();
        } else {
            var serial = new SerialModel();
            //console.log('campaign', this.campaign);
            serial.setModelFromDataModel(this.campaign);
            this.modalController.serialModal
                .setSerial(serial)
                .setTag('detail')
                .show();

            // this.modalController.serialModal
            //     .onClickAction(data => {
            //         if (data) {
            //             switch(data.action) {
            //                 case 'history':
            //                     this.cbRedeemSuccess.sendCallback({page: '/history/burn'});
            //                     break;
            //             }
            //         }
            //     });

            // this.modalController.serialModal
            //     .onClickClose(data => {
            //         console.log(data);
            //     });
        }
    };
    //#endregion serial

    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function () {
        this.isLoading = false;
        this.modalController.loadingModal.hide();
    };
    //#endregion loading

    //#region event
    // redeem success
    this.onRedeemSuccess = function(callback) {
        this.cbRedeemSuccess.onCallback(callback);
    };
    this.eventRedeemSuccess = function(info) {
        this.cbRedeemSuccess.sendCallback(info);
    };

    //error api
    this.onErrorApi = function(callback) {
        this.cbApiError.onCallback(callback);
    };
    this.eventErrorApi = function(info) {
        this.cbApiError.sendCallback(info);
    };

    //redirect
    this.onRedirect = function(callback) {
        this.cbRedirect.onCallback(callback);
    };
    this.eventRedirect = function(info) {
        this.cbRedirect.sendCallback(info);
    };
    //#endregion event
    //#region custom
    this.setTotalPoint = (usePoint) => {
        this.usePoint = usePoint;
    }
    //#endregion custom
}
